import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    cssOverrides: {
        tooltipBody: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 60%;
                            height: 5rem;
                            overflow-y: auto;
                        `,
                        css`
                            width: 60%;
                            height: 5rem;
                            overflow-y: auto;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};
